'use client'

import dynamic from 'next/dynamic'

export const UserAuthDialog = dynamic(
  () => import('components/user-auth-dialog').then(mod => mod.UserAuthDialog),
  {
    ssr: false,
  },
)

export const GDPRPopup = dynamic(
  () => import('../../components/cf-popups/gdpr').then(mod => mod.GDPRConsent),
  {
    ssr: false,
  },
)

export const PaymentsCompleteScreenDialog = dynamic(
  () =>
    import('payments/payments-dialog/components/payments-complete-screen-dialog-modal').then(
      mod => mod.PaymentsCompleteScreenDialog,
    ),
  {
    ssr: false,
  },
)

export const TicketGenieSnippet = dynamic(
  () => import('../../components/ticket-genie').then(mod => mod.TicketGenieSnippet),
  {
    ssr: false,
  },
)

export const SitewidePopup = dynamic(
  () => import('../../components/cf-popups').then(mod => mod.SitewidePopup),
  {
    ssr: false,
  },
)
